import React, { useState } from 'react';
// import PasswordShow from '../../assets/icons/passwordShow-icon.svg';
// import PasswordHide from '../../assets/icons/passwordHide-icon.svg';
// import Icon from '../../assets/icons/Icon';

const PasswordInput = ({
    name = 'password',
    value = '',
    onChange,
    placeholder = 'Enter Password',
    label = 'Password',
    error
}) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="passwordSection gap-[6px] flex flex-col relative">
            <div className="passwordLabel flex justify-between">
                <span className="text-dark-grey dark:text-white font-normal text-base leading-5 tracking-[-0.24px]">{label}</span>
            </div>
            <div className="passwordField pr-3 rounded-md border border-[#AFC3BC] h-11 flex items-center justify-between gap-3 bg-white dark:darkThemeGradiantBg dark:border-none relative">
                <input
                    type={showPassword ? 'text' : 'password'}
                    data-testid={`${name}-input`}
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className="w-full py-2.5 px-3 pr-10 text-lg leading-6 rounded-md text-dark-grey dark:text-white h-full bg-white dark:bg-transparent  dark:placeholder:text-white/40 placeholder:text-dark-grey/40 dark:placeholder:text-white dark:placeholder:opacity-40 font-medium tracking-[-0.408px] outline-none"
                    placeholder={placeholder}
                />
                <div
                    className="eyeIcon cursor-pointer opacity-50"
                    data-testid={`${name}-visibility-toggle`}
                    onClick={() => setShowPassword((prev) => !prev)}
                >
                    {showPassword ? (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_3379_10991)" className='*:dark:stroke-white'>
                                <path d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className='dark:stroke-white'></path>
                                <path d="M11.9998 20.27C15.5298 20.27 18.8198 18.19 21.1098 14.59C22.0098 13.18 22.0098 10.81 21.1098 9.39997C18.8198 5.79997 15.5298 3.71997 11.9998 3.71997C8.46984 3.71997 5.17984 5.79997 2.88984 9.39997C1.98984 10.81 1.98984 13.18 2.88984 14.59C5.17984 18.19 8.46984 20.27 11.9998 20.27Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_3379_10991"><rect width="24" height="24" fill="white"></rect></clipPath>
                            </defs>
                        </svg>
                    ) : (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_3379_10992)" className='*:dark:stroke-white'>
                                <path
                                    d="M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z"
                                    stroke="#292D32" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round"></path>
                                <path
                                    d="M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77"
                                    stroke="#292D32" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round"></path>
                                <path
                                    d="M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993"
                                    stroke="#292D32" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round"></path>
                                <path
                                    d="M15.5104 12.7C15.2504 14.11 14.1004 15.26 12.6904 15.52"
                                    stroke="#292D32" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round"></path>
                                <path d="M9.47 14.53L2 22" stroke="#292D32" strokeWidth="1.5"
                                    strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M22.0003 2L14.5303 9.47" stroke="#292D32"
                                    strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round"></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_3379_10992">
                                    <rect width="24" height="24" fill="white"></rect>
                                </clipPath>
                            </defs>
                        </svg>
                    )}
                </div>
            </div>
            {error && (
                <p
                    className='text-sm text-critical font-normal leading-5 absolute -bottom-5'
                    data-testid={`${name}-error`}
                >
                    {error}
                </p>
            )}
        </div>
    );
};

export default PasswordInput;
